import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

/**
 * Show error toast notification
 * @param {Object} vm - Vue component instance
 * @param {string} title - Toast title
 * @param {string} message - Toast message
 */
export function showErrorToast(vm, title, message) {
  vm.$toast({
    component: ToastificationContent,
    props: {
      title: title || 'Error',
      text: message,
      icon: 'AlertCircleIcon',
      variant: 'danger'
    }
  })
}

/**
 * Show success toast notification
 * @param {Object} vm - Vue component instance
 * @param {string} title - Toast title
 * @param {string} message - Toast message
 */
export function showSuccessToast(vm, title, message) {
  vm.$toast({
    component: ToastificationContent,
    props: {
      title: title || 'Success',
      text: message,
      icon: 'CheckIcon',
      variant: 'success'
    }
  })
}

/**
 * Show warning toast notification
 * @param {Object} vm - Vue component instance
 * @param {string} title - Toast title
 * @param {string} message - Toast message
 */
export function showWarningToast(vm, title, message) {
  vm.$toast({
    component: ToastificationContent,
    props: {
      title: title || 'Warning',
      text: message,
      icon: 'AlertCircleIcon',
      variant: 'warning'
    }
  })
}

/**
 * Show info toast notification
 * @param {Object} vm - Vue component instance
 * @param {string} title - Toast title
 * @param {string} message - Toast message
 */
export function showInfoToast(vm, title, message) {
  vm.$toast({
    component: ToastificationContent,
    props: {
      title: title || 'Info',
      text: message,
      icon: 'InfoIcon',
      variant: 'info'
    }
  })
}
